import styled from "styled-components";

export const FAQStyle = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 666.58px;
  background-color: #dcdcdc;
  letter-spacing: 0.3px;

  .info {
    margin-bottom: 80px;
    text-align: center;
    & h3 {
      text-transform: uppercase;
    }
  }

  ul {
    list-style-type: none;
    margin: auto;
    & li {
      cursor: pointer;
      & span {
        margin-right: 10px;
      }
    }
  }
`;

export const Button = styled.button`
  background-color: #dcdcdc;
  color: white;
`;
